import moment from "moment";

export const tabs = [
  { title: "Geographical Regions", value: "1" },
  { title: "Task Category", value: "2" },
  { title: "Task Term", value: "3" },
  { title: "Submodule", value: "4" },
  // { title: "Inventory Setup", value: "5" },
  { title: "KIT Master", value: "6" },
  { title: "Invoice Code", value: "7" },
  { title: "Curriculum Master", value: "8" },
  // { title: "KIT Type", value: "9" },
];
